import type { Distance } from "@pdfking/math"
import { Abs } from "@pdfking/math"
import { ZERO_DISTANCE } from "@pdfking/math/constants"

import type { BoxPointLists } from "#internal"

export const MirrorY = (lines: BoxPointLists, center: Distance = ZERO_DISTANCE): BoxPointLists =>
  [...lines].reverse().map(line =>
    [...line].reverse().map(point => ({
      ...point,
      y: (center - Abs(center - point.y)) as Distance,
    }))
  )
